import * as React from 'react';
import { displayUserNameLong } from '../helpers/displayHelpers';
import { OrgUser } from '../types';
import { antGrey, getAvatarColorForName } from './styles/globalStyles';
import pilotWings from '../../assets/release-pilot-wings.svg';
import Tooltip from 'antd/lib/tooltip';
import Avatar from 'antd/lib/avatar';

interface AvatarProps {
    isDisabled?: boolean;
}
interface OwnerAvatarGroupProps extends AvatarProps {
    maxAvatars: number;
    owners: OrgUser[];
}
export const OwnerAvatarGroup: React.FC<OwnerAvatarGroupProps> = (props: OwnerAvatarGroupProps) => {
    const { maxAvatars, owners, isDisabled } = props;
    return (
        <Avatar.Group
            maxCount={maxAvatars}
            maxPopoverTrigger="click"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
            }}
            maxStyle={{
                color: isDisabled ? antGrey.grey6 : antGrey.grey8,
                backgroundColor: antGrey.grey4,
                border: 'none',
                cursor: 'pointer',
                marginLeft: 0,
                width: '25px',
                height: '25px',
                fontSize: 12,
                lineHeight: '22px',
            }}
            size={25}
            className="release-overview-avatar-group"
        >
            {owners.map((owner) => {
                const ownerNameString = displayUserNameLong(owner);
                const ownerAvatar = (
                    <div>
                        <OwnerAvatar user={owner} isDisabled={isDisabled} />
                    </div>
                );
                return isDisabled ?
                        <>{ownerAvatar}</>
                    :   <Tooltip key={owner.id} title={ownerNameString} placement="top">
                            <>{ownerAvatar}</>
                        </Tooltip>;
            })}
        </Avatar.Group>
    );
};

interface OwnerAvatarProps extends AvatarProps {
    user: OrgUser;
}
export const OwnerAvatar: React.FC<OwnerAvatarProps> = (props: OwnerAvatarProps) => {
    const { user, isDisabled } = props;
    const userName = displayUserNameLong(user);

    return (
        <Avatar
            style={{
                fontSize: 12,
                border: 'none',
                backgroundColor: getAvatarColorForName(userName),
                flexShrink: 0,
                opacity: isDisabled ? '30%' : '100%',
            }}
            size={25}
            src={user.commsAvatars?.image32}
        >
            {userName.charAt(0).toUpperCase()}
        </Avatar>
    );
};

export const ReleasePilotAvatar: React.FC<AvatarProps> = (props: AvatarProps) => {
    const avatar = (
        <img src={pilotWings} width={32} height={32} style={{ opacity: props.isDisabled ? '30%' : '100%' }} />
    );
    return (
        <>
            {props.isDisabled ?
                <>{avatar}</>
            :   <Tooltip title={'This item is owned by the current Release pilot'} placement="topRight">
                    <>{avatar}</>
                </Tooltip>
            }
        </>
    );
};
